// src/features/fourlink-config/hooks/useTurnos.js

import { useState, useEffect, useMemo, useCallback } from 'react';
import { 
  loadHorariosFromStorage, 
  saveHorariosToStorage,
  normalizeTurnoId,
  normalizeHorarioEntry
} from '../utils/storage/horarioStorage';
import { formatHorarioRange } from '../utils/helpers/formatters';
import { isPlainObject } from '../utils/helpers/filters';

export const useTurnos = (tareasConfiguracion) => {
  const [horariosDisponibles, setHorariosDisponibles] = useState([]);
  const [horariosHydrated, setHorariosHydrated] = useState(false);

  // Cargar horarios del storage
  useEffect(() => {
    const storedHorarios = loadHorariosFromStorage();
    if (Array.isArray(storedHorarios) && storedHorarios.length > 0) {
      setHorariosDisponibles(storedHorarios);
    }
    setHorariosHydrated(true);
  }, []);

  // Guardar horarios cuando cambien
  useEffect(() => {
    if (!horariosHydrated) return;
    saveHorariosToStorage(horariosDisponibles);
  }, [horariosDisponibles, horariosHydrated]);

  // Obtener turnos asignados por tarea
  const turnosAsignadosPorTarea = useMemo(() => {
    if (!isPlainObject(tareasConfiguracion)) {
      return {};
    }
    return Object.entries(tareasConfiguracion).reduce((acc, [tareaId, config]) => {
      const turnos = isPlainObject(config?.turnos) ? config.turnos : null;
      if (!turnos) {
        return acc;
      }
      const seleccionados = Array.isArray(turnos.seleccionados)
        ? turnos.seleccionados.map((id) => normalizeTurnoId(id)).filter(Boolean)
        : [];
      acc[tareaId] = {
        habilitado: Boolean(turnos.habilitado),
        ids: seleccionados,
      };
      return acc;
    }, {});
  }, [tareasConfiguracion]);

  // Agregar nuevo horario
  const addHorario = useCallback((name) => {
    const existingIds = new Set(
      horariosDisponibles
        .map((horario) => normalizeTurnoId(horario?.id))
        .filter(Boolean)
    );
    
    let baseId = `custom-${Date.now()}`;
    while (existingIds.has(baseId)) {
      baseId = `custom-${Date.now()}-${Math.floor(Math.random() * 1000)}`;
    }

    const nuevoTurno = {
      id: baseId,
      name,
      startTime: '',
      endTime: '',
      isCustom: true,
    };

    setHorariosDisponibles((prev) => [...prev, nuevoTurno]);
    return nuevoTurno;
  }, [horariosDisponibles]);

  return {
    horariosDisponibles,
    setHorariosDisponibles,
    horariosHydrated,
    turnosAsignadosPorTarea,
    addHorario,
  };
};